import { useEffect, useState } from "react";

import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  Card,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";

import {
  DataGrid,
  GridToolbar,
  GridRowData,
  GridColumns,
} from "@mui/x-data-grid";

import classes from "./index.module.scss";

type Props = {
  dataSet: GridRowData[];
  columns: GridColumns;
  isLoading: boolean;
  showSearch: boolean;
  onRowClick?: (rowData: GridRowData) => void;
};

const innerTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const Table = (props: Props) => {
  const { dataSet, columns, isLoading, showSearch, onRowClick } = props;
  const [searchFilter, setSearchFilter] = useState<string>("");
  const [displayDataSet, setDisplayDataSet] = useState<GridRowData[]>([]);

  useEffect(() => {
    let filteredDataSet = dataSet;

    if (searchFilter.length > 0) {
      filteredDataSet = dataSet.filter((el) =>
        el.uid.startsWith(searchFilter)
      );
    } 

    setDisplayDataSet(filteredDataSet);
  }, [searchFilter, dataSet]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={innerTheme}>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            padding: showSearch ? 20 : 0,
          }}
        >
          {showSearch && (
            <TextField
              label="Search by Device ID"
              onChange={(event) => setSearchFilter(event.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              variant="standard"
            />
          )}
          <Card
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
            className={classes.container}
          >
            <DataGrid
              rows={displayDataSet}
              {...{ columns }}
              disableSelectionOnClick
              onRowClick={(row) => (onRowClick ? onRowClick(row.row) : null)}
              loading={isLoading}
              getRowId={(row) => row.uid}
              components={{
                Toolbar: GridToolbar,
              }}
            />
          </Card>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default Table;
